module.exports = __webpack_public_path__ + "static/img/nodata3.fd48c73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nodata3.png
// module id = EhbO
// module chunks = 54